<template>
  <div v-if="mainConfig.enableAuth && !is_authorized" class="ta-lot-view-login-signup-buttons">
    <hr>
    <p>{{ $t('Log in or create an account to bid and join the auction action.') }}</p>
    <div class="row">
      <div class="col">
        <SignupButton />
      </div>
      <div class="col">
        <LoginButton />
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import LoginButton from "@/components/lot-view/sidebar/LoginButton.vue";
import SignupButton from "@/components/lot-view/sidebar/SignupButton.vue";

export default {
  name: "LoginSignupButtons",
  components: {SignupButton, LoginButton},
  computed: {
    ...mapState(['mainConfig']),
    ...mapGetters(['is_authorized'])
  }
}
</script>

<style lang="scss">
.artisio-webapp-page-auction-view-timed .ta-lot-view-login-signup-buttons {
  //width: 320px;
  > .row {
    > .col {
      margin-bottom: 1rem;
    }
  }
  hr {
    display: none;
  }
}
</style>
